<template>
  <div :class="rootClass">
    <a :class="`${cn}__link`" :href="link">
      <div :class="`${cn}__wrapper`">
        <!-- {# ----- DATE BLOCK ----- #} -->
        <div :class="`${cn}__date`">
          <div :class="`${cn}__start flex`">
            <span :class="`${cn}__value`">{{ formattedStartDate }}</span>
            <span :class="`${cn}__weekday font-sans`">{{ formattedStartWeekday }}</span>
            <span v-if="props.startTime" :class="`${cn}__time font-sans`">{{ formattedStartTime }} Uhr</span>
          </div>

          <span v-if="props.endDate" :class="`${cn}__value hidden sm:block`">-</span>

          <div v-if="props.endDate" :class="`${cn}__end hidden sm:flex`">
            <span :class="`${cn}__value`">{{ formattedEndDate }}</span>
            <span :class="`${cn}__weekday font-sans`">{{ formattedEndWeekday }}</span>
            <span v-if="props.endTime" :class="`${cn}__time font-sans`">{{ formattedEndTime }} Uhr</span>
          </div>
        </div>

        <!-- {# ----- DESCRIPTION BLOCK ----- #} -->
        <div :class="`${cn}__content`">
          <div :class="`${cn}__markette`">
            <Markette v-if="label" :modifiers="['small']" :text="label" />
          </div>

          <h4 :class="`${cn}__headline`">
            <span v-html="headline"></span>
          </h4>

          <p :class="`${cn}__dayTime`" v-show="locationTown && locationTitle">
            <span :class="`${cn}__descriptionText`">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 9.6c0 4.8-7 11.4-7 11.4S5 14.4 5 9.6C5 5.955 8.134 3 12 3s7 2.955 7 6.6Zm-7 3.15c1.718 0 3.111-1.343 3.111-3s-1.393-3-3.111-3c-1.718 0-3.111 1.343-3.111 3s1.393 3 3.111 3Z"/></svg>
              <span class="font-sans font-medium">{{ locationTown }}, {{ locationTitle }}</span>
            </span>
          </p>
        </div>
      </div>
    </a>
  </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import Markette from '../../_atoms/markette/_component.vue';
import useRootClass from '../../../src/composables/useRootClass';
import { computed } from 'vue';

interface ITeaserDateSidebarItemProps {
  headline: string;
  startDate: string;
  link: string;
  modifiers?: [];
  label?: string;
  locationTown?: string;
  locationTitle?: string;
  endDate?: string | null;
  startTime?: string | null;
  endTime?: string | null;
}

const props = withDefaults(defineProps<ITeaserDateSidebarItemProps>(), {
  modifiers: () => [],
  label: '',
  locationTown: '',
  locationTitle: '',
  endDate: null,
  startTime: null,
  endTime: null,
});

const cn = 'm-teaserDateSitebarItem';
const { rootClass } = useRootClass({
  cn,
  modifiers: props.modifiers,
});

dayjs.locale('de');

const formattedStartDate = computed(() => {
  return dayjs(props.startDate).format('DD.MM.');
});

const formattedEndDate = computed(() => {
  return dayjs(props.endDate).format('DD.MM.');
});

const formattedStartWeekday = computed(() => {
  return dayjs(props.startDate).format('dddd');
});

const formattedEndWeekday = computed(() => {
  return dayjs(props.endDate).format('dddd');
});

const formattedStartTime = computed(() => {
  return dayjs(props.startTime).format('HH:mm');
});

const formattedEndTime = computed(() => {
  return dayjs(props.endTime).format('HH:mm');
});
</script>
